import { api } from "./client.js";
export const slotsApi = {
    list: (venue, date) => api.get("api/slots", { searchParams: { venue, date } }).json(),
};
